/**
 * Atlas Casino Theme Configuration
 * Single source of truth for all colors and styling
 */

export const theme = {
  // Background colors
  bg: "#070B14",
  bgCard: "#0a0e1a",
  card: "rgba(255,255,255,0.02)",
  cardHover: "rgba(255,255,255,0.04)",

  // Border colors
  border: "rgba(255,255,255,0.06)",
  borderLight: "rgba(255,255,255,0.1)",
  borderHover: "rgba(255,255,255,0.12)",

  // Text colors (t1 = brightest, t5 = dimmest)
  t1: "#FFFFFF",
  t2: "rgba(255,255,255,0.8)",
  t3: "rgba(255,255,255,0.5)",
  t4: "rgba(255,255,255,0.3)",
  t5: "rgba(255,255,255,0.15)",

  // Brand colors
  purple: "#7B2FF7",
  purpleSoft: "rgba(123,47,247,0.15)",
  purpleLight: "#A78BFA",
  teal: "#00D4AA",
  tealLight: "#5EEAD4",
  tealSoft: "rgba(0,212,170,0.1)",

  // Gradients
  grad: "linear-gradient(to right, #7B2FF7, #00D4AA)",
  gradCard: "linear-gradient(135deg, #1a1035, #0d1b2a)",
  gradPurple: "linear-gradient(to right, #7B2FF7, #9333EA)",

  // Shadows
  purpleGlow: "0 10px 30px rgba(123,47,247,0.3)",
  purpleShadow: "0 8px 20px rgba(123,47,247,0.2)",
  tealGlow: "0 0 4px rgba(94,234,212,0.5)",

  // Status colors
  success: "#4ADE80",
  successBg: "rgba(34,197,94,0.1)",
  warning: "#FBBF24",
  warningBg: "rgba(234,179,8,0.1)",
  warningLight: "#FDE047",
  error: "#F87171",
  errorBg: "rgba(239,68,68,0.1)",

  // Font families
  fontPrimary: "'DM Sans', sans-serif",
  fontMono: "'Space Mono', monospace",
};

// Google Fonts import URL
export const FONTS_URL = "https://fonts.googleapis.com/css2?family=DM+Sans:opsz,wght@9..40,400;9..40,500;9..40,700&family=Space+Mono:wght@400;700&display=swap";

// Common CSS keyframe animations
export const animations = `
  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(10px); }
    to { opacity: 1; transform: translateY(0); }
  }
  @keyframes fadeSlideUp {
    from { opacity: 0; transform: translateY(15px); }
    to { opacity: 1; transform: translateY(0); }
  }
  @keyframes float {
    0% { transform: translateY(0) rotate(0); }
    100% { transform: translateY(-40px) rotate(3deg); }
  }
  @keyframes pulseGlow {
    0%, 100% { box-shadow: 0 0 30px rgba(123,47,247,0.3); }
    50% { box-shadow: 0 0 60px rgba(123,47,247,0.5), 0 0 90px rgba(0,212,170,0.2); }
  }
  @keyframes shimmer {
    0% { background-position: -200% 0; }
    100% { background-position: 200% 0; }
  }
  @keyframes balancePop {
    0% { transform: translateY(0); opacity: 1; }
    100% { transform: translateY(-20px); opacity: 0; }
  }
  @keyframes spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }
  .shimmer-text {
    background: linear-gradient(90deg, #fff 0%, #7B2FF7 25%, #00D4AA 50%, #7B2FF7 75%, #fff 100%);
    background-size: 200% auto;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    animation: shimmer 4s linear infinite;
  }
`;

export default theme;
